import { render, staticRenderFns } from "./WorkflowTaskModal.vue?vue&type=template&id=2f722dcf&"
import script from "./WorkflowTaskModal.vue?vue&type=script&lang=js&"
export * from "./WorkflowTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports